import React, { useEffect, useState } from "react";
import moment from "moment";
import { Drawer, Tabs, DatePicker, Upload } from "antd";
import { useSnackbar } from "notistack";
import Select from "react-select";
import { AiOutlineDelete, AiOutlineInbox } from "react-icons/ai";

import { usePet, useToggle, useListData, notifOps } from "../../modules";
import Receive from "../../components/reusable/receive";
import { useSelector } from "react-redux";

import { useHistory, Link, Switch, Route, useLocation } from "react-router-dom";

import Instituion from "./institution";
import Attachments from "./attachments";
import Referee from "./referee";

const { TabPane } = Tabs;
const { Dragger } = Upload;

const NewEmployee = ({ path, onPerform }) => {
  const [string, setString] = useState();
  const [name, setName] = useState();
  const [workEmail, setWorkEmail] = useState();
  const [personalEmail, setPersonalEmail] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [gender, setGender] = useState();
  const [dob, setDOB] = useState();
  const [age, setAge] = useState(0);
  const [dateNow, setDateNow] = useState(moment().startOf("day"));
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [locality, setLocality] = useState();
  const [nokName, setNokName] = useState();
  const [nokPhone, setNokPhone] = useState();
  const [nokRship, setNokRship] = useState();
  const [documentType, setDocType] = useState({
    label: "National ID",
    value: "National ID",
  });
  const [passport, setPassport] = useState([]);
  const [passportName, setPassportName] = useState();
  const [index, setIndex] = useState(0);
  const [identification, setID] = useState();
  const [practitionerRegulator, setPractitionerRegulator] = useState();
  const [practitionerId, setPractitionerId] = useState();
  const [country, setCountry] = useState({ label: "Kenya", value: "Kenya" });
  const [region, setRegion] = useState();

  const [institutions, setInstitutions] = useState([]);
  const [attachments, setAttachments] = useState([
    {
      uuid: " ",
      fileNme: "File Name",
      label: "National ID",
      description: "Employees National ID",
      required: true,
    },
    {
      uuid: " ",
      fileNme: "File Name",
      label: "NSSF",
      description: "Employees NSSF",
      required: true,
    },
    {
      uuid: " ",
      fileNme: "File Name",
      label: "NHIF",
      description: "Employees NHIF",
      required: true,
    },
  ]);
  const [fileList, setFileList] = useState([]);
  const [paymentFreq, setPaymentFreq] = useState();
  const [salary, setSalary] = useState();
  const [currency, setCurrency] = useState();
  const [paymentMethod, setPaymentMethod] = useState();
  const [bankName, setBankName] = useState();
  const [bankBranch, setBankBranch] = useState();
  const [accountNo, setAccountNo] = useState();
  const [accountName, setAccountName] = useState();
  const [referee, setReferee] = useState([]);

  const [title, setTitle] = useState();
  const [supervisor, setSupervisor] = useState();
  const [department, setDepartment] = useState();
  const [tab, setTab] = useState("0");

  const [visible, toggleVisible] = useToggle(true);

  const { enqueueSnackbar } = useSnackbar();

  const history = useHistory();

  const { params } = useSelector((state) => state.application);


  const freq = [
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "bimonthly", label: "BiMonthly" },
  ];

  const currenc = [
    { value: "KES", label: "KES" },
    { value: "USD", label: "USD" },
  ];

  const paymentMeth = [
    { value: "Bank", label: "Bank" },
    { value: "cash", label: "Cash" },
    { value: "cheque", label: "Cheque" },
  ];

  const viewInstitution = (i) => {
    setIndex(i);
    setTimeout(() => history.push(`${path}/new/institution/${i}`), 300);
  };

  const viewAttachment = (i) => {
    console.log("Viewing Attachment");
    setIndex(i);
    setTimeout(() => history.push(`${path}/new/attachments/${i}`), 300);
  };

  const viewReferee = (i) => {
    setIndex(i);
    setTimeout(() => history.push(`${path}/new/referee/${i}`), 300);
  };

  const removeInstitution = (i) =>
    setInstitutions((inst) => inst.filter((_, x) => x !== i));

  const removeAttachment = (i) =>
    setAttachments((inst) => inst.filter((_, x) => x !== i));

  const removeReferee = (i) =>
    setReferee((ref) => ref.filter((_, x) => x !== i));

  const close = () => {
    toggleVisible();
    setTimeout(() => history.goBack(), 300);
  };

  const clear = () => {
    setName();
    setWorkEmail();
    setPersonalEmail();
    setPhone();
    setGender();
    setAddress();
    setDOB();
    setAge();
    setCountry();
    setRegion();
    setLocality();
    setNokName();
    setNokPhone();
    setNokRship();
  };

  const modify = (e) => {
    switch (e.target.name) {
      case "name":
        setName(e.target.value);
        break;

      case "workEmail":
        setWorkEmail(e.target.value);
        break;

      case "personalEmail":
        setPersonalEmail(e.target.value);
        break;

      case "phone":
        setPhone(e.target.value);
        break;

      case "address":
        setAddress(e.target.value);
        break;

      case "dob":
        setDOB(e.target.value);
        break;

      case "age":
        setAge(e.target.value);
        break;

      case "locality":
        setLocality(e.target.value);
        break;

      case "nokName":
        setNokName(e.target.value);
        break;

      case "nokPhone":
        setNokPhone(e.target.value);
        break;

      case "nokRship":
        setNokRship(e.target.value);
        break;

      case "identification":
        setID(e.target.value);
        break;

      case "practitionerRegulator":
        setPractitionerRegulator(e.target.value);
        break;

      case "practitionerId":
        setPractitionerId(e.target.value);
        break;

      case "institution":
        setInstitutions(e.target.value);
        break;

      case "salary":
        setSalary(e.target.value);
        break;

      case "paymentFreq":
        setPaymentFreq(e.target.value);
        break;

      case "paymentMethod":
        setPaymentMethod(e.target.value);
        break;

      case "title":
        setTitle(e.target.value);
        break;

      case "bankName":
        setBankName(e.target.value);
        break;

      case "bankBranch":
        setBankBranch(e.target.value);
        break;

      case "accountName":
        setAccountName(e.target.value);
        break;

      case "accountNo":
        setAccountNo(e.target.value);
        break;

      case "supervisor":
        setSupervisor(e.target.value);
        break;

      default:
        break;
    }
  };


  const onComplete = ({ data }, notif, ops) => {
    onPerform(data);
    notif("Employee has been added", ops("success"));
    setTimeout(close, 300);
  };

  const [{ loading }, addEmployee] = usePet(
    "newEmployee",
    {
      name,
      phone,
      dob,
      age,
      documentType: documentType?.value,
      identification,
      practitionerRegulator,
      practitionerId,
      workEmail,
      personalEmail,
      gender: gender?.value,
      passportName,
      department: department?.value,
      title,
      salary,
      paymentFreq: paymentFreq?.value,
      paymentMethod: paymentMethod?.value,
      bankName,
      bankBranch,
      accountName,
      accountNo,
      supervisor: supervisor?.value,
      country: country?.value,
      region: region?.value,
      locality,
      address,
      nokName,
      nokRship,
      nokPhone,
      referee: referee?.map((ref) => ({
        name: ref?.refName,
        title: ref?.title,
        organization: ref?.organization,
        phone: ref?.phoneNo,
        email: ref?.email,
      })),
      institutions: institutions?.map(
        ({
          name,
          begunOn,
          graduatedOn,
          faculty,
          course,
          finalGrade,
          documents,
        }) => ({
          name,
          begunOn,
          graduatedOn,
          faculty,
          course,
          finalGrade,
          documents,
        })
      ),
      attachments: attachments?.map((attach) => ({
        name: attach?.label,
        file: attach?.fileNme,
        description: attach?.description,
      })),
      fileList: fileList?.flat().map((file) => file.originFileObj),
      passport: passport?.map((file) => file.originFileObj),
    },
    { notify: true, hasFile: true, callback: onComplete, manual: true }
  );

  const [
    { loading: sLoading, error: sError, fetch: sFetch },
    { list: supervisors },
  ] = useListData(
    "supervisors",
    { string, limit: 100 },
    { notify: true, manual: false }
  );

  const [{ loading: cLoading }] = usePet("countries", null, {
    notify: true,
    callback: ({ data }) => setCountries(data),
  });

  const [{ loading: rLoading }, fetchRegions] = usePet(
    "regions",
    { name: country?.label },
    { notify: true, callback: ({ data }) => setRegions(data) }
  );

  const changeCountry = (val) => {
    setCountry(val);
    setRegion();
    fetchRegions();
  };

  const props = {
    name: "passport",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    fileList: passport,
    onChange: (file) => {
      let { fileList } = file;
      let isPDF =
        fileList[0]?.type === "application/pdf" ||
        fileList[0]?.type === "image/jpeg" ||
        fileList[0]?.type === "image/jpg" ||
        fileList[0]?.type === "image/png";
      console.log(fileList[0]?.type, " the file type.....");

      let isNotPDF = !isPDF;
      if (isNotPDF) {
        enqueueSnackbar(
          "Please upload either an image or pdf",
          notifOps("warning")
        );
        return false;
      }
      let isLarge = fileList[0]?.size / 1024 / 1024 > params?.maxFileUploadSize;
      if (isLarge)
        enqueueSnackbar(
          `Please upload a file smaller than ${params?.maxFileUploadSize} MB`,
          notifOps("warning")
        );

      if (!(isNotPDF || isLarge))
        setPassport(fileList)
        setPassportName(fileList[0]?.name);
    },
    onRemove: (file) => {
      const filt = passport.filter((itm) => itm.uid !== file.uid)
      setPassport(filt)
    },
    beforeUpload: () => false,
    onDrop: (e) => {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const handleFiles = (file) => {
    setFileList((prevList) => [...prevList, file]);
  };

  const newInst = () => {
    setInstitutions((inst) => {
      return [
        ...inst,
        {
          name: `Institution ${institutions.length + 1}`,
          begunOn: "2024-09-11",
          graduatedOn: "2024-09-11",
          faculty: "Science & Tech",
          course: "IT",
          finalGrade: "First Class",
          documents: ["Degree"],
        },
      ];
    });
  };

  const newAttachment = () => {
    setAttachments((attach) => {
      return [
        ...attach,
        {
          fileNme: `Attachment ${attachments.length + 1}`,
          label: "Label",
          description: "description",
        },
      ];
    });
  };

  const newReferee = () => {
    setReferee((ref) => {
      return [
        ...ref,
        {
          refName: `Referee ${referee.length + 1}`,
          phoneNo: "0712345678",
          title: "Lecturer",
          organization: "UON",
          email: "ref@gmail.com",
        },
      ];
    });
  };

  const saveInstitution = (val, i) => {
    let temp = [...institutions];
    temp[i] = {
      ...temp[i],
      ...val,
    };
    setInstitutions(temp);
  };

  const saveAttachments = (val, i) => {
    let temp = [...attachments];
    temp[i] = {
      ...temp[i],
      ...val,
    };
    setAttachments(temp);
  };

  const saveReferee = (val, i) => {
    let temp = [...referee];
    temp[i] = {
      ...temp[i],
      ...val,
    };
    setReferee(temp);
  };
   console.log(institutions, " the institutions......")
  useEffect(() => {
    const getAge = () => {
      const dobMoment = moment(dob);
      let empAge = dateNow.diff(dobMoment, "years");

      setAge(empAge);
    };

    getAge()
  }, [dob])

  return (
    <Drawer
      closable
      maskClosable
      visible={visible}
      onClose={close}
      footer={
        <div className="w-full text-right">
          <button
            disabled={loading}
            onClick={() => {
              passport.length > 0
                ? addEmployee()
                : enqueueSnackbar(
                    "Please Upload employees passport :)",
                    notifOps("error")
                  );
            }}
            className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          >
            Add New Employee
          </button>
        </div>
      }
      width={990}
    >
      <p className="font-extrabold text-3xl mb-0">New Employee</p>
      <Tabs onChange={setTab} activeKey={tab} className="min-h-full">
        <TabPane key="0" tab="Employee Details">
          <div className="divide-y divide-light-gray-400">
            <div>
              <div>
                <div>
                  <p className="font-bold my-3">Basic Information</p>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Name
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-name"
                        type="text"
                        value={name}
                        name="name"
                        placeholder="Evans Kimani"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-gender"
                      >
                        Gender
                      </label>
                      <Select
                        value={gender}
                        onChange={setGender}
                        options={["Male", "Female"].map((item) => ({
                          label: item,
                          value: item,
                        }))}
                        placeholder="Select Gender"
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mb-3 -mx-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-email"
                      >
                        Date of Birth
                      </label>
                      <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-dob"
                        name="dob"
                        value={dob}
                        onChange={modify}
                        type="date"
                        placeholder="Date Of Birth"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Age
                      </label>
                      <input
                        disabled
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-age"
                        type="number"
                        value={age}
                        name="age"
                        placeholder="0"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <p className="font-bold my-3">Passport</p>
                  <div className="w-full md:w-1/2 px-5 ml-28 mb-6 md:mb-2 lg:mb-4">
                    <Dragger
                      {...props}
                      style={{ width: 510, height: 80, marginLeft: 20 }}
                    >
                      <p className="ant-upload-drag-icon flex justify-center">
                        <AiOutlineInbox size={40} />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag file to this area to upload Passport
                      </p>
                      <p className="ant-upload-hint">
                        Please select a pdf or image file (jpg/jpeg/png)
                      </p>
                    </Dragger>
                  </div>
                </div>
                <div>
                  <p className="font-bold my-3">Identification Information</p>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-gender"
                      >
                        Identification Type
                      </label>
                      <Select
                        value={documentType}
                        onChange={setDocType}
                        options={["National ID", "Millitary ID"].map(
                          (item) => ({ label: item, value: item })
                        )}
                        placeholder="Select ID Type"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-identification"
                      >
                        Identification No.
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-identification"
                        type="text"
                        value={identification}
                        name="identification"
                        placeholder="34XXXXXX"
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-2/5 px-3 mr-20 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-practitioner-regulator"
                      >
                        Practitioner Regulator
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-practitioner-regulator"
                        type="text"
                        value={practitionerRegulator}
                        name="practitionerRegulator"
                        placeholder="KMPDC"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-practitioner-id"
                      >
                        Practitioner ID
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-practitioner-id"
                        type="text"
                        value={practitionerId}
                        name="practitionerId"
                        placeholder="KMPDC/XXXX"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <p className="font-bold my-3">Contact Information</p>
                  <div className="flex flex-wrap -mx-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <span>
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-name"
                        >
                          Work Email
                        </label>
                      </span>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-email"
                        type="email"
                        value={workEmail}
                        name="workEmail"
                        placeholder="user@email.com"
                      />
                    </div>
                    <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Phone
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-phone"
                        type="text"
                        value={phone}
                        name="phone"
                        placeholder="07XXXXXXXX"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20 mb-6 md:mb-0">
                      <span>
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-name"
                        >
                          Personal Email
                        </label>
                      </span>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-email"
                        type="email"
                        value={personalEmail}
                        name="personalEmail"
                        placeholder="user@email.com"
                      />
                    </div>
                  </div>
                  <p className="font-bold my-3">Residential Information</p>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-county"
                      >
                        Country
                      </label>
                      <Select
                        isLoading={cLoading}
                        value={country}
                        onChange={changeCountry}
                        options={countries.map((item) => ({
                          label: item,
                          value: item,
                        }))}
                        placeholder="Select Country"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-county"
                      >
                        Region
                      </label>
                      <Select
                        isLoading={rLoading}
                        value={region}
                        onChange={setRegion}
                        options={regions.map((item) => ({
                          label: item,
                          value: item,
                        }))}
                        placeholder="Select Region"
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Locality
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-locality"
                        type="text"
                        value={locality}
                        name="locality"
                        placeholder="Kamangu"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Address
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-locality"
                        type="number"
                        value={address}
                        name="address"
                        placeholder="001-4355"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <p className="font-bold my-3">Next of Kin Information</p>
                  <div className="flex flex-wrap -mx-3">
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <span>
                        <label
                          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-name"
                        >
                          Name
                        </label>
                      </span>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-nokname"
                        type="text"
                        value={nokName}
                        name="nokName"
                        placeholder="Kamau Samuel"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Relationship
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-nokrship"
                        type="text"
                        value={nokRship}
                        name="nokRship"
                        placeholder="Relationship"
                      />
                    </div>
                    <div className="w-full md:w-2/5 px-3 mr-20  mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Phone
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-nokphone"
                        type="text"
                        value={nokPhone}
                        name="nokPhone"
                        placeholder="07XXXXXXXX"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane key="1" tab="Education Details">
          <div className="divide-y divide-light-gray-400">
            <div>
              <div>
                <p className="font-extrabold text-xl mb-0">Education Details</p>
                {institutions?.length > 0 ? (
                  <>
                    <table className="table-auto w-full">
                      <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                          <th className="p-2 pl-4 text-center">No</th>
                          <th className="p-2 pl-4 text-center">Institution</th>
                          <th className="p-2 pl-4 text-center">Begun On</th>
                          <th className="p-2 pl-4 text-center">Graduated On</th>
                          <th className="p-2 pl-4 text-center">Faculty</th>
                          <th className="p-2 pl-4 text-center">Course</th>
                          <th className="p-2 pl-4 text-center">Final Grade</th>
                          <th className="p-2 pl-4 text-center">
                            {" "}
                            Certifications{" "}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm font-medium divide-y divide-gray-100">
                        {institutions.map((inst, key) => (
                          <tr>
                            <td className="p-2 h-5 text-center">{key + 1}</td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.name}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.begunOn}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.graduatedOn}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.faculty}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.course}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{inst?.finalGrade}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              {inst?.documents ?
                                inst.documents.map((item, index) => (
                                <div className="" key={index}>{item}</div>
                              )):
                              <span>No documents</span>
                              }
                            </td>
                            <td className="p-2 h-5 text-center">
                              <button
                                onClick={() => viewInstitution(key)}
                                className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                              >
                                View
                              </button>

                              <button
                                onClick={() => removeInstitution(key)}
                                className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text"
                              >
                                <AiOutlineDelete className="font-base" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="w-full h-16 text-center">
                      <button
                        onClick={newInst}
                        className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                      >
                        Add New Institution
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="w-full h-16 text-center">
                    <button
                      onClick={newInst}
                      className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                    >
                      Add New Institution
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane key="5" tab="Attachments">
          <div className="divide-y divide-light-gray-400">
            <div>
              <div>
                <p className="font-extrabold text-xl mb-0">Attachments</p>
                {attachments?.length > 0 ? (
                  <>
                    <table className="table-auto w-full mb-2">
                      <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                          <th className="p-2 pl-4 text-center">No</th>
                          <th className="p-2 pl-4 text-center">Label</th>
                          <th className="p-2 pl-4 text-center">Description</th>
                          <th className="p-2 pl-4 text-center">FileName</th>
                        </tr>
                      </thead>
                      <tbody className="text-sm font-medium divide-y divide-gray-100">
                        {attachments.map((attach, key) => (
                          <tr>
                            <td className="p-2 h-5 text-center">{key + 1}</td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{attach?.label}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{attach?.description}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <div className="">{attach?.fileNme}</div>
                            </td>
                            <td className="p-2 h-5 text-center">
                              <button
                                onClick={() => viewAttachment(key)}
                                className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                              >
                                View
                              </button>

                              <button
                                onClick={() => removeAttachment(key)}
                                className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text"
                                hidden={attach?.required}
                              >
                                <AiOutlineDelete className="font-base" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="w-full h-16 text-center">
                      <button
                        onClick={newAttachment}
                        className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                      >
                        Add New Attachment
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="w-full h-16 text-center">
                    <button
                      onClick={newAttachment}
                      className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                    >
                      Add New Attachment
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane key="2" tab="Payroll Details">
          <div className="">
            <p className="font-bold my-3">Salary Information</p>
            <div className="flex flex-wrap -mx-3 mb-3 space-x-32">
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-name"
                >
                  Salary
                </label>
                <input
                  className="appearance-none block w-40 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 mr-4 leading-tight focus:outline-none focus:bg-white"
                  id="grid-salary"
                  name="salary"
                  value={salary}
                  onChange={modify}
                  type="number"
                  placeholder="Amount"
                />
              </div>
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-frequency"
                >
                  Payment Frequency
                </label>
                <Select
                  value={paymentFreq}
                  onChange={setPaymentFreq}
                  options={freq}
                  placeholder="Select payment frequency"
                />
              </div>
            </div>
            <p className="font-bold my-3">Payment Information</p>
            <div className="flex flex-wrap -mx-3 mb-3 space-x-32">
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-name"
                >
                  Currency
                </label>
                <Select
                  value={currency}
                  onChange={setCurrency}
                  options={currenc}
                  placeholder="Select Currency"
                />
              </div>
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-frequency"
                >
                  Payment Method
                </label>
                <Select
                  value={paymentMethod}
                  onChange={setPaymentMethod}
                  options={paymentMeth}
                  placeholder="Select payment Method"
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-3 space-x-32">
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-name"
                >
                  Bank Name
                </label>
                <input
                  className="appearance-none block w-40 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 mr-4 leading-tight focus:outline-none focus:bg-white"
                  id="grid-bankName"
                  name="bankName"
                  value={bankName}
                  onChange={modify}
                  type="text"
                  placeholder="CBK"
                />
              </div>
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-frequency"
                >
                  Branch Name
                </label>
                <input
                  className="appearance-none block w-40 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 mr-4 leading-tight focus:outline-none focus:bg-white"
                  id="grid-bankName"
                  name="bankBranch"
                  value={bankBranch}
                  onChange={modify}
                  type="text"
                  placeholder="Nairobi"
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-3 space-x-32">
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-name"
                >
                  Account Name
                </label>
                <input
                  className="appearance-none block w-40 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 mr-4 leading-tight focus:outline-none focus:bg-white"
                  id="grid-accountName"
                  name="accountName"
                  value={accountName}
                  onChange={modify}
                  type="text"
                  placeholder="John Doe Doh"
                />
              </div>
              <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 m-4 whitespace-nowrap"
                  htmlFor="grid-frequency"
                >
                  Account No
                </label>
                <input
                  className="appearance-none block w-40 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 mr-4 leading-tight focus:outline-none focus:bg-white"
                  id="grid-accountNo"
                  name="accountNo"
                  value={accountNo}
                  onChange={modify}
                  type="text"
                  placeholder="M17710n5"
                />
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane key="3" tab="Referees">
          <div className="divide-y divide-light-gray-400">
            <div>
              <p className="font-extrabold text-xl mb-0">Referee Details</p>
              {referee?.length > 0 ? (
                <>
                  <table className="table-auto w-full">
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                      <tr>
                        <th className="p-2 pl-4 text-center">No</th>
                        <th className="p-2 pl-4 text-center">Name</th>
                        <th className="p-2 pl-4 text-center">Title</th>
                        <th className="p-2 pl-4 text-center">Organization</th>
                        <th className="p-2 pl-4 text-center">Phone Number</th>
                        <th className="p-2 pl-4 text-center">Email</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                      {referee.map((ref, key) => (
                        <tr>
                          <td className="p-2 h-5 text-center">{key + 1}</td>
                          <td className="p-2 h-5 text-center">
                            <div className="">{ref?.refName}</div>
                          </td>
                          <td className="p-2 h-5 text-center">
                            <div className="">{ref?.title}</div>
                          </td>
                          <td className="p-2 h-5 text-center">
                            <div className="">{ref?.organization}</div>
                          </td>
                          <td className="p-2 h-5 text-center">
                            <div className="">{ref?.phoneNo}</div>
                          </td>
                          <td className="p-2 h-5 text-center">
                            <div className="">{ref?.email}</div>
                          </td>
                          <td className="p-2 h-5 text-center">
                            <button
                              onClick={() => viewReferee(key)}
                              className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                            >
                              View
                            </button>

                            <button
                              onClick={() => removeReferee(key)}
                              className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text"
                            >
                              <AiOutlineDelete className="font-base" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="w-full h-16 text-center">
                    <button
                      onClick={newReferee}
                      className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                    >
                      Add New Referee
                    </button>
                  </div>
                </>
              ) : (
                <div className="w-full h-16 text-center">
                  <button
                    onClick={newReferee}
                    className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                  >
                    Add New Referee
                  </button>
                </div>
              )}
            </div>
          </div>
        </TabPane>
        <TabPane key="4" tab="Organisational Details">
          <div className="divide-y divide-light-gray-400">
            <div>
              <div>
                <div>
                  <p className="font-bold my-3">Work Details</p>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-3/5 px-3 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Job Description
                      </label>
                      <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-title"
                        type="text"
                        value={title}
                        name="title"
                        placeholder="System Admin"
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-3/5 px-3 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Department
                      </label>
                      <Select
                        value={department}
                        onChange={setDepartment}
                        options={["Maternity", "InPatient", "OutPatient"].map(
                          (item) => ({
                            label: item,
                            value: item,
                          })
                        )}
                        placeholder="Select Department"
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full md:w-3/5 px-3 mb-6 md:mb-0">
                      <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-name"
                      >
                        Supervisor
                      </label>
                      <Receive error={sError} loading={sLoading} progress>
                        <Select
                          isClearable
                          value={supervisor}
                          onChange={setSupervisor}
                          styles={{
                            input: (styles) => ({
                              ...styles,
                              minWidth: "10em",
                            }),
                          }}
                          options={supervisors?.map((supvisor) => ({
                            label: supvisor.name,
                            value: supvisor._id,
                          }))}
                          placeholder="Select Supervisor  "
                        />
                      </Receive>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>

      <Switch>
        <Route path={`${path}/new/institution/:index`}>
          <Instituion onSave={saveInstitution} record={institutions[index]} />
        </Route>
        <Route path={`${path}/new/attachments/:index`}>
          <Attachments
            handleFiles={handleFiles}
            onSave={saveAttachments}
            record={attachments[index]}
          />
        </Route>
        <Route path={`${path}/new/referee/:index`}>
          <Referee onSave={saveReferee} record={referee[index]} />
        </Route>
      </Switch>
    </Drawer>
  );
};

export default NewEmployee;
